module.exports = __webpack_public_path__ + "static/media/logo-inverse.5042dcca.svg";